import type { IFetcher } from "../../util/io/Fetcher";
import type { UploadCodeAndSourceValidationResultModel } from "../../../OpenApi/api";

export interface ICodeAndSourceValidationFetcher {
    validate(sourceId: number, code: string): Promise<UploadCodeAndSourceValidationResultModel>;
}

export class CodeAndSourceValidationFetcher implements ICodeAndSourceValidationFetcher {
    constructor(private readonly fetcher: IFetcher) {}

    async validate(sourceId: number, code: string): Promise<UploadCodeAndSourceValidationResultModel> {
        const { fetcher } = this;
        const url = "/POW4/Upload/GetCodeAndSourceValidation?sourceId=" + sourceId + "&code=" + code;
        return await fetcher.getJSON<UploadCodeAndSourceValidationResultModel>(url);
    }
}
